import React from "react";
import TextLoop from "react-text-loop";
import hofPlayers from "@data/hallOfFamePlayers";

const HOF = () => {
  let randomizeListHOFPlayers = hofPlayers
    .map((value) => ({ value, sort: Math.random() }))
    .sort((a, b) => a.sort - b.sort)
    .map(({ value }) => value);

  return (
    <div className="flex w-full flex-col items-center justify-center space-x-3 text-center text-2xl font-bold uppercase md:text-3xl lg:flex-row">
      <TextLoop className="text-redAccent">{randomizeListHOFPlayers}</TextLoop> <span>était chez Deathrow.</span>
    </div>
  );
};

export default HOF;
